import { render, staticRenderFns } from "./leader.vue?vue&type=template&id=13db6327&scoped=true&"
import script from "./leader.vue?vue&type=script&lang=js&"
export * from "./leader.vue?vue&type=script&lang=js&"
import style0 from "./leader.vue?vue&type=style&index=0&id=13db6327&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13db6327",
  null
  
)

export default component.exports